import { MyBag } from "arv-extends/constants";

const EMPTY_BAG_URL = "//static.omuni.com/wildcraft-empty-state.png";

MyBag.IMAGES.EMPTY_BAG_URL = EMPTY_BAG_URL;
MyBag.MYBAGPAGE.MYBAG_EMPTY_MSG = "That's one really empty cart....";
MyBag.MYBAGPAGE.MYBAG_TEXT = "MY CART";
MyBag.MYBAGPOPUP.MY_BAG_TEXT = "MY CART";
MyBag.MYBAGPOPUP.VIEW_SHOPPING_BAG_TEXT = "VIEW SHOPPING CART";
MyBag.MYBAGPOPUP.TOASTER_MSG = "We've removed $styleName from your cart";
export default MyBag;
